import { createAsyncThunk } from '@reduxjs/toolkit';
import { postPmEngagementAccepted, postBillingEngagementAccepted } from 'core/api/sales.api/sales.api';

export const pmEngagementAcceptedAction = createAsyncThunk(
  'pmEngagementAcceptedAction',
  async (orderId: number | string, { rejectWithValue }) => {
    try {
      await postPmEngagementAccepted(orderId);
    } catch (error) {
      return rejectWithValue(error);
    }
  });

export const billingEngagementAcceptedAction = createAsyncThunk(
  'billingEngagementAcceptedAction',
  async (orderId: number | string, { rejectWithValue }) => {
    try {
      await postBillingEngagementAccepted(orderId);
    } catch (error) {
      return rejectWithValue(error);
    }
  });
